<template>
  <section class="container">
    <slot>
      <div class="w-full h-72 bg-light-gray"></div>
    </slot>
  </section>
</template>

<script>
export default {

}
</script>

<style>

</style>